import React, { useMemo } from 'react';
import ImgView from './imgView';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import WellInfo from './wellInfo';
import AdditivesInfo from './additivesInfo';
import CrystalsInfo from './crystalsInfo';
import ProteinInfo from './proteinInfo';
import {
  useIsWellDropOrXtalSearch,
  useLatestSelectedSearchRow,
} from 'redux/hooks/searchnFilter';
import { useWellAndDropDetails } from '../hooks';
import { ISearchResultsRowMap, fieldsMap } from '../utils';

interface InfoTabWrapperProps {
  WrappedComp: (props) => JSX.Element;
  compProps?: Record<string, any>;
}
const InfoTabWrapper = (props: InfoTabWrapperProps) => {
  const { WrappedComp, compProps = {} } = props;
  return (
    <div className="max-h-[46vh] overflow-scroll top-wrapper">
      <WrappedComp {...compProps} />
    </div>
  );
};

const InfoContainer = (props) => {
  const latestSelectedRow = useLatestSelectedSearchRow();
  const isWellDropOrXtalSearch = useIsWellDropOrXtalSearch();

  const keyMap = useMemo(() => {
    let mapping: ISearchResultsRowMap = undefined;

    if (latestSelectedRow) {
      mapping = {};
      Object.entries(fieldsMap).forEach(([key, value]) => {
        mapping[key] = latestSelectedRow[value];
      });
      mapping['regionName'] = 'Drop';
    }
    return mapping;
  }, [latestSelectedRow]);

  const tabProps = useWellAndDropDetails();

  const tabComponents: ITabItem[] = useMemo(() => {
    if (!latestSelectedRow || !tabProps) {
      return [];
    }

    const { proteinProps, wellProps, additivesProps } = tabProps;
    return [
      {
        title: 'Well',
        eventKey: 'well',
        content: <WellInfo ingredientWellProps={wellProps} />,
      },
      {
        title: 'Protein',
        eventKey: 'protein',
        content: (
          <InfoTabWrapper
            WrappedComp={ProteinInfo}
            compProps={{ compProps: proteinProps }}
          />
        ),
      },
      {
        title: 'Additives',
        eventKey: 'additives',
        content: (
          <InfoTabWrapper
            WrappedComp={AdditivesInfo}
            compProps={{ compProps: additivesProps }}
          />
        ),
      },
      {
        title: 'Crystals',
        eventKey: 'crystal',
        content: (
          <InfoTabWrapper
            WrappedComp={CrystalsInfo}
            compProps={{ regionId: latestSelectedRow['Region.ID'] }}
          />
        ),
      },
    ];
  }, [latestSelectedRow, tabProps]);

  return (
    <div id="searchandfilter-infocontainer-wrapper" className="flex flex-col h-full">
      {isWellDropOrXtalSearch && latestSelectedRow?.['Capture Result.Profile Name'] && (
        <ImgView latestSelectedRow={keyMap} />
      )}
      <div id="searchandfilter-infocontainer-tabs">
        <RMTabs
          tabItems={tabComponents}
          defaultActiveKey={'well'}
          id={'searchandfilter-infocontainer-infoPanelTab'}
        />
      </div>
    </div>
  );
};

export default InfoContainer;
